module.exports = __webpack_public_path__ + "img/adhka-yx1zn.001.4d54a8d7.jpeg";